import { lazyPage } from "./lazyPage";

// The phone's critical path (Home, Quick Add, the shell) stays in the main bundle; the rest
// loads on demand so a cold start parses less.
export const BudgetPage = lazyPage(() => import("../features/budget/BudgetPage"), "BudgetPage");
export const AccountsPage = lazyPage(
  () => import("../features/accounts/AccountsPage"),
  "AccountsPage",
);
export const RegisterPage = lazyPage(
  () => import("../features/accounts/RegisterPage"),
  "RegisterPage",
);
export const ActivityPage = lazyPage(
  () => import("../features/activity/ActivityPage"),
  "ActivityPage",
);
export const CategoryPage = lazyPage(
  () => import("../features/category/CategoryPage"),
  "CategoryPage",
);
export const ImportPage = lazyPage(() => import("../features/import/ImportPage"), "ImportPage");
export const OnboardingPage = lazyPage(
  () => import("../features/onboarding/OnboardingPage"),
  "OnboardingPage",
);
export const ReportsPage = lazyPage(() => import("../features/reports/ReportsPage"), "ReportsPage");
export const SettingsPage = lazyPage(
  () => import("../features/settings/SettingsPage"),
  "SettingsPage",
);
export const TransactionPage = lazyPage(
  () => import("../features/transaction/TransactionPage"),
  "TransactionPage",
);
